/* eslint-disable */
"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PremiumResellerMgmt = void 0;
var json_proto_serializer_1 = require("@wix/json-proto-serializer");
var http_1 = require("@wix/ambassador/runtime/http");
var PremiumResellerMgmt = function (baseUrl, httpClientConfig) {
    var httpClient = new http_1.AmbassadorHTTPClient(baseUrl, httpClientConfig);
    return {
        ResellerInternal: function () {
            return function (headers) {
                var service = {
                    getExternalRedirectUrls: function (getExternalRedirectUrlsRequest) {
                        return httpClient.invoke('GET', '/resellers/v1/internal/external_redirect_urls', getExternalRedirectUrlsRequest, headers);
                    },
                    getInternalRedirectUrls: function (getInternalRedirectUrlsRequest) {
                        return httpClient.invoke('GET', '/resellers/v1/internal/internal_redirect_urls', getInternalRedirectUrlsRequest, headers);
                    },
                };
                service.getExternalRedirectUrls.__http_method = 'GET';
                service.getExternalRedirectUrls.__http_url = '/resellers/v1/internal/external_redirect_urls';
                service.getInternalRedirectUrls.__http_method = 'GET';
                service.getInternalRedirectUrls.__http_url = '/resellers/v1/internal/internal_redirect_urls';
                return service;
            };
        },
        ResellerManagement: function () {
            return function (headers) {
                var service = {
                    createReseller: function (createResellerRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [
                                        { typeName: 'google.protobuf.UInt64Value', pathInPayload: ['reseller', 'revision'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['reseller', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['reseller', 'updatedDate'] },
                                    ];
                                    serializedPayload = json_proto_serializer_1.batchToJson(createResellerRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('POST', '/resellers/v1/management', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.UInt64Value', pathInPayload: ['reseller', 'revision'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['reseller', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['reseller', 'updatedDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    deleteReseller: function (deleteResellerRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [{ typeName: 'uint64', pathInPayload: ['revision'] }];
                                    serializedPayload = json_proto_serializer_1.batchToJson(deleteResellerRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('DELETE', '/resellers/v1/management/{reseller_account_id}', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, response];
                            }
                        });
                    }); },
                    getReseller: function (getResellerRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, httpClient.invoke('GET', '/resellers/v1/management/{reseller_account_id}', getResellerRequest, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.UInt64Value', pathInPayload: ['reseller', 'revision'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['reseller', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['reseller', 'updatedDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                    updateReseller: function (updateResellerRequest) { return __awaiter(void 0, void 0, void 0, function () {
                        var requestTransformations, serializedPayload, response, responseTransformations, deSerializedResponse;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    requestTransformations = [
                                        { typeName: 'google.protobuf.UInt64Value', pathInPayload: ['reseller', 'revision'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['reseller', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['reseller', 'updatedDate'] },
                                        { typeName: 'google.protobuf.FieldMaskArray', pathInPayload: ['mask'] },
                                    ];
                                    serializedPayload = json_proto_serializer_1.batchToJson(updateResellerRequest, requestTransformations);
                                    return [4 /*yield*/, httpClient.invoke('PUT', '/resellers/v1/management/{reseller.reseller_account_id}', serializedPayload, headers)];
                                case 1:
                                    response = _a.sent();
                                    responseTransformations = [
                                        { typeName: 'google.protobuf.UInt64Value', pathInPayload: ['reseller', 'revision'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['reseller', 'createdDate'] },
                                        { typeName: 'google.protobuf.Timestamp', pathInPayload: ['reseller', 'updatedDate'] },
                                    ];
                                    deSerializedResponse = json_proto_serializer_1.batchFromJson(response, responseTransformations);
                                    return [2 /*return*/, deSerializedResponse];
                            }
                        });
                    }); },
                };
                service.createReseller.__http_method = 'POST';
                service.createReseller.__http_url = '/resellers/v1/management';
                service.deleteReseller.__http_method = 'DELETE';
                service.deleteReseller.__http_url = '/resellers/v1/management/{reseller_account_id}';
                service.getReseller.__http_method = 'GET';
                service.getReseller.__http_url = '/resellers/v1/management/{reseller_account_id}';
                service.updateReseller.__http_method = 'PUT';
                service.updateReseller.__http_url = '/resellers/v1/management/{reseller.reseller_account_id}';
                return service;
            };
        },
        ResellerSelfManagement: function () {
            return function (headers) {
                var service = {
                    getResellerConfig: function (getResellerConfigRequest) {
                        return httpClient.invoke('GET', '/resellers/v1/self-management/config', getResellerConfigRequest, headers);
                    },
                    updateResellerConfig: function (updateGetResellerConfigRequest) {
                        return httpClient.invoke('PUT', '/resellers/v1/self-management/config', updateGetResellerConfigRequest, headers);
                    },
                };
                service.getResellerConfig.__http_method = 'GET';
                service.getResellerConfig.__http_url = '/resellers/v1/self-management/config';
                service.updateResellerConfig.__http_method = 'PUT';
                service.updateResellerConfig.__http_url = '/resellers/v1/self-management/config';
                return service;
            };
        },
    };
};
exports.PremiumResellerMgmt = PremiumResellerMgmt;
exports.PremiumResellerMgmt.__transport = 'http';
__exportStar(require("./types"), exports);
//# sourceMappingURL=http.js.map